import React from 'react';
import styled, { css } from 'styled-components';

type LazyType = 'lazy' | 'eager';

const ratios = {
  '1/1': css`
    aspect-ratio: 1/1;
  `,
  '2621/3356': css`
    aspect-ratio: 2621/3356;
  `,
  '629/798': css`
    aspect-ratio: 629/798;
  `,
  '958/625': css`
    aspect-ratio: 958/625;
  `,
  '59/34': css`
    aspect-ratio: 59/34;
  `,
} as const;

export type Ratio = keyof typeof ratios;

interface ImageProps {
  src: string;
  alt: string;
  lazy: LazyType;
  imgSrcSmall: string;
  className?: string;
  ratio: Ratio;
}

interface StyledImageProps {
  $ratio: Ratio;
}

const StyledImage = styled.img<StyledImageProps>`
  width: 100%;
  height: auto;

  ${({ $ratio }) => ratios[$ratio]}
`;

const Image = ({ src, alt, lazy = 'lazy', imgSrcSmall, className, ratio = '1/1' }: ImageProps) => (
  <StyledImage
    $ratio={ratio}
    src={src}
    srcSet={`${imgSrcSmall}, ${src} 2x`}
    alt={alt}
    loading={lazy}
    className={className}
  />
);

export default Image;
